/**
 * ProductRouter — maps a product slug to its bespoke page component.
 * Falls back to the generic ProductPage for any slug without a custom design.
 */
import { useParams } from 'react-router-dom';
import BubbleProduct    from './products/BubbleProduct';
import GlaceProduct     from './products/GlaceProduct';
import BlueCremeProduct from './products/BlueCremeProduct';
import VerdeProduct     from './products/VerdeProduct';
import ProductPage      from './ProductPage';

const REGISTRY = {
  'bubble':     BubbleProduct,
  'glace':      GlaceProduct,
  'blue-creme': BlueCremeProduct,
  'verde':      VerdeProduct,
};

export default function ProductRouter() {
  const { slug } = useParams();
  const Bespoke = REGISTRY[slug];
  return Bespoke ? <Bespoke /> : <ProductPage />;
}
